// GDPR Privacy Policy content (IT/EN)
export const privacyPolicy = {
  it: {
    updated: "Ultimo aggiornamento: Luglio 2026",
    intro: "La presente informativa descrive come NC&C Luxury tratta i dati personali degli utenti che utilizzano questo sito web, in conformità al Regolamento (UE) 2016/679 (GDPR).",
    sections: [
      {
        title: "1. Titolare del trattamento",
        body: [
          "Il titolare del trattamento è NC&C Luxury, P.IVA 10252461214, con sede in Via Domenico Colasanto 15, 80126 Napoli (Italia).",
          "Per qualsiasi richiesta relativa ai dati personali è possibile contattarci ai recapiti indicati nella pagina Contatti.",
        ],
      },
      {
        title: "2. Dati raccolti",
        body: [
          "Raccogliamo i dati che l'utente fornisce volontariamente compilando il modulo di prenotazione o di contatto: nome e cognome, indirizzo email, numero di telefono, dettagli del viaggio (data, orario, tragitto, numero di passeggeri, bagagli, tipo di servizio) ed eventuali note aggiuntive.",
          "Possono essere raccolti automaticamente dati tecnici di navigazione (indirizzo IP, tipo di browser) tramite cookie tecnici.",
        ],
      },
      {
        title: "3. Finalità e base giuridica",
        body: [
          "I dati sono trattati per rispondere alle richieste di prenotazione e di contatto, per fornire i servizi richiesti e per adempimenti di legge.",
          "La base giuridica è l'esecuzione di misure precontrattuali e contrattuali (art. 6.1.b GDPR) e il consenso dell'interessato (art. 6.1.a GDPR).",
        ],
      },
      {
        title: "4. Conservazione dei dati",
        body: [
          "I dati sono conservati per il tempo strettamente necessario alle finalità indicate e comunque nel rispetto dei termini di legge, dopodiché vengono cancellati o resi anonimi.",
        ],
      },
      {
        title: "5. Comunicazione dei dati",
        body: [
          "I dati non vengono ceduti a terzi per finalità commerciali. Possono essere trattati da fornitori di servizi tecnici (es. hosting) che agiscono come responsabili del trattamento.",
        ],
      },
      {
        title: "6. Diritti dell'interessato",
        body: [
          "L'utente ha diritto di accedere ai propri dati, richiederne la rettifica o la cancellazione, limitarne o opporsi al trattamento, e alla portabilità dei dati.",
          "Per esercitare tali diritti è sufficiente contattarci. L'utente ha inoltre diritto di presentare reclamo al Garante per la protezione dei dati personali.",
        ],
      },
      {
        title: "7. Cookie",
        body: [
          "Questo sito utilizza cookie tecnici necessari al funzionamento. Con il consenso dell'utente possono essere utilizzati cookie aggiuntivi per migliorare l'esperienza di navigazione.",
        ],
      },
    ],
  },
  en: {
    updated: "Last updated: July 2026",
    intro: "This policy describes how NC&C Luxury processes the personal data of users who use this website, in compliance with Regulation (EU) 2016/679 (GDPR).",
    sections: [
      {
        title: "1. Data Controller",
        body: [
          "The data controller is NC&C Luxury, VAT no. 10252461214, based at Via Domenico Colasanto 15, 80126 Naples (Italy).",
          "For any request regarding personal data you can contact us using the details provided on the Contacts page.",
        ],
      },
      {
        title: "2. Data Collected",
        body: [
          "We collect the data you voluntarily provide when filling in the booking or contact form: full name, email address, phone number, journey details (date, time, route, number of passengers, luggage, service type) and any additional notes.",
          "Technical browsing data (IP address, browser type) may be collected automatically via technical cookies.",
        ],
      },
      {
        title: "3. Purpose and Legal Basis",
        body: [
          "Data is processed to respond to booking and contact requests, to provide the requested services and to comply with legal obligations.",
          "The legal basis is the performance of pre-contractual and contractual measures (art. 6.1.b GDPR) and the consent of the data subject (art. 6.1.a GDPR).",
        ],
      },
      {
        title: "4. Data Retention",
        body: [
          "Data is kept only for the time strictly necessary for the stated purposes and in compliance with legal terms, after which it is deleted or anonymised.",
        ],
      },
      {
        title: "5. Data Disclosure",
        body: [
          "Data is not sold to third parties for commercial purposes. It may be processed by technical service providers (e.g. hosting) acting as data processors.",
        ],
      },
      {
        title: "6. Your Rights",
        body: [
          "You have the right to access your data, request its rectification or erasure, restrict or object to processing, and data portability.",
          "To exercise these rights simply contact us. You also have the right to lodge a complaint with the data protection authority.",
        ],
      },
      {
        title: "7. Cookies",
        body: [
          "This site uses technical cookies necessary for its operation. With your consent, additional cookies may be used to improve the browsing experience.",
        ],
      },
    ],
  },
};
